import { isSuperAdminEmail } from '@/lib/constants'
import type { UserProfile } from '@/lib/types'

/**
 * Can the signed-in admin change role/plan of this profile? Mirrors the second `allow update` of
 * `users` in ../firestore_prod.rules. The rules are the real check — this only lets the UI disable a
 * button and say why, instead of letting the user hit PERMISSION_DENIED.
 */
export function accessChangeBlockReason(
  target: UserProfile,
  currentUid: string | undefined,
): string | null {
  if (target.uid === currentUid) {
    return 'Свою роль, тариф и доступ изменить нельзя — защита от потери доступа. Попросите другого администратора.'
  }
  if (isSuperAdminEmail(target.email)) {
    return 'Это супер-администратор: его роль, тариф и доступ не может изменить ни один клиент, только консоль Firebase.'
  }
  return null
}

/** Human-readable reason for a rejected write. */
export function describeWriteError(error: unknown): string {
  const code = (error as { code?: string }).code ?? ''
  if (code === 'permission-denied') {
    return 'Firestore отклонил запись. Убедитесь, что правила с новым блоком users опубликованы, и что вы не пытаетесь изменить себя или супер-администратора.'
  }
  if (code === 'unavailable') return 'Нет связи с Firestore. Попробуйте позже.'
  return (error as { message?: string }).message ?? 'Не удалось сохранить изменения.'
}
